<app-skeleton-template *ngIf="!loadInfo" [template]="skeletonTemplate"></app-skeleton-template>


<ng-container *ngIf="loadInfo && recordMedicalPersonal">
  <p class="text-info mb-sm">Selecciona las enfermedades que padeces o hayas padecido en algún momento.</p>
  <div class="tw-p-5 tw-rounded-md tw-mb-5 tw-border tw-border-solid tw-border-gray-100" *ngFor="let category of diseaseCategories; index as i">
    <div nz-row [nzGutter]="[30, 30]">
      <div nz-col [nzXs]="24">
        <label class="tw-flex tw-items-center">
          <div class="tw-flex tw-items-center">
            <img [src]="'./../../../assets/images/icons/' + category.icon" class="tw-w-8 tw-mr-2" alt="">
            <p class="text-info">{{ category.name }}</p>
          </div>
        </label>
      </div>
      <nz-collapse nzGhost class="tw-w-full tw-shadow-none">
        <ng-template #header>
          <div class="tw-flex tw-items-center tw-h-4 tw-w-full tw-pr-7">
            <p class="tw-text-gray-900 tw-text-sm truncate">
              Enfermedades relacionadas. <span *ngIf="!collapse.nzActive" @fadeInAnimation class="tw-text-gray-600">{{ category.diseases | stringifyArray: 'name' }}</span>
            </p>
          </div>
        </ng-template>
        <nz-collapse-panel
          #collapse
          [nzHeader]="header">
          <p class="text-info tw-ml-4 tw-mt-3">{{ category.diseases && category.diseases.length > 0 ? 'Por favor selecciona las enfermedades presentadas por el paciente.' : 'No se han establecido enfermedades en la categoría.' }}</p>
          <div nz-col [nzXs]="24" *ngFor="let disease of category.diseases; index as j">
            <label nz-checkbox class="tw-mb-3" [(ngModel)]="disease.active" [nzDisabled]="disableForm" (ngModelChange)="checkedDiseaseChange($event, disease, category.name)">{{ disease.name }}</label>
            <ng-container *ngIf="disease.active">
              <p class="input-label-form">Medicamentos</p>
              <textarea
                nz-input
                placeholder="Escribe los medicamentos"
                [nzAutosize]="{ minRows: 2, maxRows: 6 }" [(ngModel)]="disease.medicine" [disabled]="disableForm" (ngModelChange)="updateMedicine($event, disease)"></textarea>
              <p class="input-label-form tw-mt-3">Tratamiento</p>
              <textarea
                nz-input
                placeholder="Escribe el tratamiento"
                [nzAutosize]="{ minRows: 2, maxRows: 6 }" [(ngModel)]="disease.treatment" [disabled]="disableForm" (ngModelChange)="updateTreatment($event, disease)"></textarea>
              <p class="input-label-form tw-mt-3">Control</p>
              <nz-select [(ngModel)]="disease.control"
                         [disabled]="this.disableForm"
                         class="tw-w-full"
                  (ngModelChange)="updateDiseaseControl($event, disease)"
              >
                <nz-option *ngFor="let option of diseaseControlOptions"
                           [nzValue]="option"
                           [nzLabel]="option | getTranslateEnum: 'medicalDiseaseControl'"></nz-option>
              </nz-select>
            </ng-container>
          </div>
        </nz-collapse-panel>
      </nz-collapse>
    </div>
  </div>

  <div class="tw-p-5 tw-rounded-md tw-mb-5 tw-border tw-border-solid tw-border-gray-100">
    <div nz-row [nzGutter]="[30, 30]">
      <div nz-col [nzXs]="24">
        <label nz-checkbox [(ngModel)]="recordMedicalPersonal.hasSurgery" [nzDisabled]="disableForm" (ngModelChange)="onChangeSurgery($event)" class="tw-flex tw-items-center">
          <div class="tw-flex tw-items-center">
            <img src="./../../../assets/images/icons/icons8-surgeon-100.png" class="tw-w-8 tw-mr-2" alt="">
            <p class="text-info">Cirugías</p>
          </div>
        </label>
      </div>
      <div *ngIf="recordMedicalPersonal.hasSurgery" @fadeInAnimation class="tw-w-full">
        <p class="text-info tw-ml-4 tw-mt-3">Por favor ingresa la o las cirugías que hayas tenido.</p>
      <div nz-col [nzXs]="24">
        <textarea
          nz-input
          placeholder="Escribe las cirugías"
          [nzAutosize]="{ minRows: 2, maxRows: 6 }" [(ngModel)]="recordMedicalPersonal.surgeries" [disabled]="disableForm"></textarea>
      </div>
      </div>
    </div>
  </div>

  <div class="tw-p-5 tw-rounded-md tw-border tw-border-solid tw-border-gray-100">
    <div nz-row [nzGutter]="[30, 30]">
      <div nz-col [nzXs]="24">
        <label nz-checkbox [(ngModel)]="recordMedicalPersonal.hasProsthesis" [nzDisabled]="disableForm" (ngModelChange)="onChangeProsthesis($event)" class="tw-flex tw-items-center">
          <div class="tw-flex tw-items-center">
            <img src="./../../../assets/images/icons/icons8-pacemaker-64.png" class="tw-w-8 tw-mr-2" alt="">
            <p class="text-info">¿Tienes prótesis actualmente, marcapasos o stent?</p>
          </div>
        </label>
      </div>
      <div nz-col [nzXs]="24" *ngIf="recordMedicalPersonal.hasProsthesis" @fadeInAnimation>
        <p class="input-label-form">¿Desde cuándo?</p>
        <nz-date-picker [nzFormat]="this.platformConfig.FORMAT.DATE.DDMMYYYY" [nzPlaceHolder]="'Selecciona la Fecha'"
          [nzDisabledDate]="utilitiesService.disabledDate" [(ngModel)]="recordMedicalPersonal.startDateProsthesis" [nzDisabled]="disableForm"></nz-date-picker>
        <p class="input-label-form tw-mt-3">Si es una prótesis indica en que parte.</p>
        <textarea
          nz-input
          placeholder="Escribe el lugar de la prótesis"
          [nzAutosize]="{ minRows: 2, maxRows: 6 }" [(ngModel)]="recordMedicalPersonal.prosthesisBodyPart" [disabled]="disableForm"></textarea>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-end" *ngIf="!disableForm && !isInnerRecord">
    <button class="mt-xlg" nz-button nzType="primary" (click)="onSave()"><i nz-icon nzType="save" nzTheme="outline"></i>GUARDAR</button>
  </div>
</ng-container>

